import React from 'react';
import { ScrollView } from 'react-native';
import Stage from './Stage';
import UpcomingEvents from './UpcomingEvents';
import Header from '../../components/Header/Header.web';
import HostTeaser from './HostTeaser';
import Footer from '../../components/footer/Footer';
import MeetPeople from './MeetPeople';
import Press from './Press';

function PublicHome() {
  return (
    <ScrollView contentContainerStyle={{ alignItems: 'center' }}>
      <Header />
      <Stage />
      <UpcomingEvents />
      <HostTeaser />
      <MeetPeople />
      <Press />
      <Footer />
    </ScrollView>
  );
}

export default PublicHome;
